
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'CategoryLayoutPage',
    scrollToTop: true,
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        filters: state => state.listings.filters,
        listings: state => state.listings.listings,
        showLargeProductCards: state => state.showLargeProductCards,
        listingsPageContent: state => state.listings.listingsPageContent,
      }),
      ...mapGetters({
        hasFilters: 'listings/hasFilters',
      }),
      showFilterButtons() {
        return this.hasFilters
      },
    },
  }
